import { Badge, Icon, BlockStack, Button, Card, IndexTable, InlineStack, OptionList, Popover, Text, TextField, Tooltip, useIndexResourceState, Avatar, Link, Tag, Page, Spinner, ActionList, useBreakpoints, ButtonGroup, Banner, EmptyState, useSetIndexFiltersMode, IndexFilters } from "@shopify/polaris";
import { ArrowLeftIcon, AutomationIcon, DeleteIcon, ExternalIcon, HideIcon, LogoInstagramIcon, LogoTiktokIcon, LogoYoutubeIcon, ThumbsUpIcon, PersonIcon, PlusCircleIcon, PlusIcon, SearchIcon, SendIcon, ViewIcon, ImageIcon, CursorIcon, CashDollarIcon, CreditCardIcon, ContractIcon, StarIcon, LogoGoogleIcon } from "@shopify/polaris-icons";
import { collection, doc, setDoc } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCreatorStatus, getCreatorStatusTag } from "../components/atoms";
import BucketButton from "../components/BucketButton";
import AddCreatorModal from "../components/creators/AddCreatorModal";
import SearchProfile from "../components/creators/SearchProfile";
import AppLayout from "../components/layout";
import ManageBuckets from "../components/ManageBuckets";
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";
import { getBestAvatar, getCountry, numberToUSD, shortenNumber } from "../utils";

function TabOption({ name, quantity }) {
  return (
    <InlineStack gap="200" blockAlign="center">
      <Text>{name}</Text>
      <Badge>{quantity}</Badge>
    </InlineStack>
  )
}
export default function Creators({
  saveCreator
}) {
  const { db, leads, buckets, someLoading, subscriptions, refetchLeads, setInviteModalState, user, auth, refetchUser, outreachInvites, setToast, deals } = usePartnerUp();

  const navigate = useNavigate()
  const [hideLoading, setHideLoading] = useState(false)

  const [extensionLoaded, setExtensionLoaded] = useState(false)

  const [manageBucketsOpen, setManageBucketsOpen] = useState(false)

  const [addCreatorOpen, setAddCreatorOpen] = useState(false)

  const [creatorOpenID, setCreatorOpenID] = useState(null)

  const [changeBucketIndex, setChangeBucketIndex] = useState(null)

  const creatorOpen = leads?.find(l => l.id === creatorOpenID)

  useEffect(() => {
    setTimeout(() => {
      setExtensionLoaded(true)
    }, 2000)
  }, [])

  function getTargetFollowers(followers, profileData) {
    if (!followers) {
      return followers
    }
    const targetCustomers = user?.filters
    if (!user?.filters) {
      return followers * (profileData?.credibility || 1)
    }
    const ageWeights = targetCustomers?.ageGroups?.length ? profileData?.ages?.reduce((acc, ageStat) => {
      if (targetCustomers.ageGroups.includes(ageStat.code)) {
        acc += (ageStat.weight || 0)
      }
      return acc
    }, 0) : 1
    const genderWeights = targetCustomers?.genders?.length ? profileData?.genders?.reduce((acc, genderStat) => {
      if (targetCustomers.genders?.includes(genderStat.code)) {
        acc += (genderStat.weight || 0)
      }
      return acc
    }, 0) : 1
    const countryWeights = targetCustomers?.countries?.length ? profileData?.geoCountries?.reduce((acc, countryStat) => {
      if (targetCustomers.countries.includes(countryStat.name)) {
        acc += (countryStat.weight || 0)
      }
      return acc
    }, 0) : 1

    const credibility = profileData?.credibility || 1

    console.log('credibility', credibility)

    return followers * ageWeights * genderWeights * countryWeights * credibility
  }


  console.log('leads are', leads)

  const filteredLeads = leads;

  const { selectedResources, allResourcesSelected, handleSelectionChange } =
    useIndexResourceState(filteredLeads || []);

  const selectedLeads = useMemo(() => leads?.filter(creator => {
    return selectedResources.includes(creator.id)
  }), [selectedResources])

  async function exportCreators() {
    let exportLeads
    if (selectedResources?.length) {
      exportLeads = selectedLeads;
    } else {
      let pageLeads = leads.filter(c => {
        if (selected === 0) {
          return !c.hidden
        } else if (selected === buckets.length + 1) {
          return !c.exported && !c.hidden
        } else if (selected === buckets.length + 2) {
          return c.hidden
        } else {
          return c.buckets?.includes(buckets[selected - 1].id)
        }
      })
      exportLeads = pageLeads
    }
    try {
      const csvContent = "data:text/csv;charset=utf-8," + "Email,Name,Platform,Handle,URL,Followers,Fake Followers,Qualified Followers,Country,Age Group,Engagement Rate,Average Views\n" +
        exportLeads.map(lead => {
          console.log('lead is', lead?.profile?.audience?.credibility)
          const platform = lead?.platform || lead?.profile?.platform
          const handle = lead?.handle || lead?.profile?.handle || lead?.profile?.profile?.username || lead?.profile?.profile?.handle
          const url = lead?.profile?.profile?.url || (platform && handle ? `https://www.${platform}.com/${platform === 'tiktok' || platform === 'youtube' ? '@' : ''}${handle}` : '-')
          return `${lead?.email || lead?.profile?.contacts?.find(c => c?.type === 'email')?.value || '-'},${lead?.name || lead?.fullname || '-'},${platform || '-'},${handle || '-'},${url || '-'},${lead?.followers ? lead?.followers : '-'},${lead?.credibility ? ((1 - lead?.credibility) * 100).toFixed(2) + '%' : '-'},${Math.floor(getTargetFollowers(lead?.followers, lead)) || '-'},${lead?.country || '-'},${lead?.ageGroup || '-'},${(lead?.engagementRate ? (lead?.engagementRate * 100).toFixed(2) + '%' : '-')},${lead?.avgReelsPlays || lead?.averageViews || '-'}`
        }).join("\n");
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "partnerup-creators.csv");
      document.body.appendChild(link); // Required for FF
      link.click();
    } catch (e) {
      setToast({
        content: 'Failed To Export',
        error: true,
      })
    } finally {
      setToast({
        content: 'Exported',
      });
      await Promise.all(exportLeads.map(lead => {
        return setDoc(doc(db, 'usersV2', auth.currentUser.uid, 'creators', lead.id), {
          exported: new Date().toISOString()
        }, { merge: true })
      }))
      refetchLeads()
    }
  }

  async function hide(hide = true, hideCreators = null) {
    try {
      setHideLoading(true)

      await Promise.all((hideCreators || selectedResources).map(creatorID => {
        return setDoc(doc(db, 'usersV2', auth.currentUser.uid, 'creators', creatorID), {
          hidden: hide
        }, { merge: true })
      }))

      setToast({
        content: 'Hide Updated',
      })
      refetchLeads()
      handleSelectionChange('all', false, [])
    } catch (err) {
      console.error('error', err)
      setToast({
        content: `Failed To Hide`,
        error: true,
      })
    } finally {
      setHideLoading(false)
    }
  }

  console.log('manageBucketsOpen', manageBucketsOpen)

  const itemStrings = ['All', ...(buckets || []).map(b => {
    return `${b.emoji} ${b.name}`
  }), 'Not Exported', 'Hidden']
  const tabs = itemStrings.map((item, index) => ({
    content: item,
    index,
    onAction: () => { },
    id: `${item}-${index}`,
    isLocked: index === 0,
    actions: []
  }));
  const [selected, setSelected] = useState(0);

  const sortOptions = [
    { label: 'Added Date', value: 'added asc', directionLabel: 'Ascending' },
    { label: 'Added Date', value: 'added desc', directionLabel: 'Descending' },
    { label: 'Followers', value: 'followers asc', directionLabel: 'Ascending' },
    { label: 'Followers', value: 'followers desc', directionLabel: 'Descending' },
    { label: 'Qualified', value: 'qualified asc', directionLabel: 'Ascending' },
    { label: 'Qualified', value: 'qualified desc', directionLabel: 'Descending' },
  ];
  const [sortSelected, setSortSelected] = useState(['added desc']);
  const { mode, setMode } = useSetIndexFiltersMode();
  const [queryValue, setQueryValue] = useState('');

  const rowMarkup = filteredLeads?.filter(c => {
    if (queryValue) {
      return c?.name?.toLowerCase().includes(queryValue.toLowerCase()) || c?.handle?.toLowerCase().includes(queryValue.toLowerCase())
    }
    if (selected === 0) {
      return !c.hidden
    } else if (selected === buckets.length + 1) {
      return !c.exported && !c.hidden
    } else if (selected === buckets.length + 2) {
      return c.hidden
    } else {
      return c.buckets?.includes(buckets[selected - 1].id)
    }
  }).sort((a, b) => {
    if (sortSelected[0] === 'followers asc') {
      return a.followers - b.followers
    } else if (sortSelected[0] === 'followers desc') {
      return b.followers - a.followers
    } else if (sortSelected[0] === 'qualified asc') {
      return getTargetFollowers(a.followers, a) - getTargetFollowers(b.followers, b)
    } else if (sortSelected[0] === 'qualified desc') {
      return getTargetFollowers(b.followers, b) - getTargetFollowers(a.followers, a)
    } else if (sortSelected[0] === 'added asc') {
      return new Date(a.added) - new Date(b.added)
    } else if (sortSelected[0] === 'added desc') {
      return new Date(b.added) - new Date(a.added)
    }
  }).map((creator, index) => {
    const creatorPlatform = creator.platform
    const targetFollowers = getTargetFollowers(creator?.followers, creator)

    return (
      <IndexTable.Row
        id={creator.id}
        key={creator.id}
        selected={selectedResources.includes(creator.id)}
        position={index}
      >
        <IndexTable.Cell>
          <InlineStack gap="200" align="start">
            <Avatar size="xl" shape="square" source={creator?.picture} initials={creator?.name?.[0]} />
            <BlockStack align="center">
              <InlineStack gap="100" blockAlign="center" align="start">
                <Link removeUnderline onClick={() => {
                  navigate(`/creators/${creator.id}`)
                  // handleChangeDeal(deal)
                }}>
                  <Text variant="headingMd" fontWeight="bold" as="span">
                    {creator.name}
                  </Text>
                </Link>
                {
                  !creator?.seen ? (
                    <Badge status="info">New</Badge>
                  ) : null
                }
              </InlineStack>
              <InlineStack align="start" gap="100">
                <Text as="span">
                  {'@' + (creator.handle)}
                </Text>
              </InlineStack>
            </BlockStack>
          </InlineStack>
        </IndexTable.Cell>
        <IndexTable.Cell>
          {creator.email || '-'}
        </IndexTable.Cell>
        <IndexTable.Cell>
          <InlineStack align="start" blockAlign="center" gap="100">
            <InlineStack>
              {
                creatorPlatform === 'instagram' ? (
                  <Icon source={LogoInstagramIcon} />
                ) : creatorPlatform === 'tiktok' ? (
                  <Icon source={LogoTiktokIcon} />
                ) : creatorPlatform === 'youtube' ? (
                  <Icon source={LogoYoutubeIcon} />
                ) : null
              }
            </InlineStack>
            <Text>
              {creator?.followers ? `${shortenNumber(creator?.followers)}` : ''}
            </Text>
          </InlineStack>
        </IndexTable.Cell>

        <IndexTable.Cell>
          {shortenNumber(targetFollowers)} ({(targetFollowers / creator?.followers * 100)?.toFixed(1)}%)
        </IndexTable.Cell>
        <IndexTable.Cell>
          {creator.engagementRate ? (creator.engagementRate * 100)?.toFixed(2) + '%' : '-'}
        </IndexTable.Cell>
        <IndexTable.Cell>
          <BucketButton
            handleCreateBucket={() => setManageBucketsOpen(true)}
            creator={creator}
            changeBucketIndex={changeBucketIndex} setChangeBucketIndex={setChangeBucketIndex} />
        </IndexTable.Cell>
        <IndexTable.Cell>
          {creator.exported ? new Date(creator.exported).toLocaleDateString() : 'Not Yet'}
        </IndexTable.Cell>
        <IndexTable.Cell>
          <ButtonGroup>
            <Button icon={creator?.hidden ? ViewIcon : HideIcon} onClick={async (e) => {
              e.stopPropagation()
              console.log('creator', creator)
              try {
                console.log('creatorID', creator.id)
                await setDoc(doc(db, 'usersV2', auth.currentUser.uid, 'creators', creator.id), {
                  hidden: !creator.hidden
                }, { merge: true })
                setToast({ content: 'Hide Updated' })
                refetchLeads()
              } catch (e) {
                console.error(e)
                setToast({ content: e.message, error: true })
              }
            }} />
          </ButtonGroup>
        </IndexTable.Cell>
      </IndexTable.Row>
    )
  })


  function getBucketName(bucketID) {
    if (bucketID === 'none') return '✖️ Uncategorized'
    const bb = buckets.find(b => b.id === bucketID)
    return `${bb?.emoji} ${bb?.name}`
  }

  console.log('creatorOpen', creatorOpen)
  if (creatorOpen) {
    const showActivity = true
    const hasDeal = false;
    const localHidden = false;
    return (
      <AppLayout>
        <Button size="large" icon={ArrowLeftIcon} onClick={() => navigate('/creators')}>Back</Button>
        <Page
          // breadcrumbs={[{ content: 'Back', onAction: backAction }]}
          fullWidth
          title={<InlineStack gap="200" align="start">
            <InlineStack gap="200" blockAlign="center">
              <Avatar shape="square" source={creatorOpen?.picture} size="xl" />
              <BlockStack>
                <InlineStack>
                  <InlineStack>
                    {
                      creatorOpen?.platform === 'instagram' ? (
                        <Icon source={LogoInstagramIcon} color="subdued" />
                      ) : creatorOpen?.platform === 'tiktok' ? (
                        <Icon source={LogoTiktokIcon} color="subdued" />
                      ) : creatorOpen?.platform === 'youtube' ? (
                        <Icon source={LogoYoutubeIcon} color="subdued" />
                      ) : null
                    }
                  </InlineStack>
                  <Link external removeUnderline url={`https://www.${creatorOpen?.platform}.com/${creatorOpen?.platform !== 'instagram' ? '@' + creatorOpen?.handle : creatorOpen?.handle}`}>
                    <Text variant="bodyLg">{creatorOpen?.handle ? `@${creatorOpen?.handle}` : creatorOpen?.platform}</Text>
                  </Link>
                  {/*
              <Text variant="bodyMd">
                {creatorOpen?.country ? `${getCountry(creatorOpen?.country)}${profileData?.city ? `, ${profileData.city} ` : ''}` : null}
              </Text>
            */}
                </InlineStack>
                <InlineStack gap="200" blockAlign="center">
                  <Text variant="headingLg">{creatorOpen?.name}</Text>
                  {
                    creatorOpen?.hidden ? (
                      <Badge status="warning">Hidden</Badge>
                    ) : null
                  }
                </InlineStack>
              </BlockStack>
            </InlineStack>
          </InlineStack>}
          // open={creatorOpen?.userId}
          primaryAction={showActivity ? ((!hasDeal && creatorOpen?.email) ? {
            content: 'Invite to Campaign',
            onAction: () => {
              setInviteModalState({
                inviting: [creatorOpen],
                open: true,
                campaignID: null,
                type: 'outreach',
              })
            },
            disabled: !creatorOpen.email || creatorOpen?.hidden
          } : null) : {
            content: alreadySaved ? 'Already Saved' : 'Save Creator',
            loading: saveLoading,
            disabled: alreadySaved || leadsLimitReached,
            onAction: async () => {
              try {
                setSaveLoading(true)
                const creatorID = await saveCreator({ ...creatorOpen, creatorID: creatorOpen?.id, email: profileData?.email })
                setCreatorOpenID(creatorID)
              } catch (e) {
                setToast({ content: e.message, error: true })
              } finally {
                setSaveLoading(false)
              }
            }
          }}
          secondaryActions={
            [
              {
                content: `${creatorOpen?.platform ? creatorOpen?.platform[0]?.toUpperCase() + creatorOpen?.platform?.slice(1) : ''} Profile`,
                external: true,
                icon: ExternalIcon,
                url: `https://www.${creatorOpen?.platform}.com/${creatorOpen?.platform !== 'instagram' ? '@' + creatorOpen?.handle : creatorOpen?.handle}`
              },
              {
                content: 'Send an Email',
                icon: SendIcon,
                disabled: !creatorOpen?.email,
                onAction: () => {
                  navigate('/emails?creatorID=' + creatorOpen?.id)
                }
              },
            ]}
          actionGroups={creatorOpen?.id ? [
            {
              title: 'More Actions',
              actions: [
                (localHidden || creatorOpen?.hidden) ? {
                  content: 'Unhide',
                  icon: ViewIcon,
                  loading: hideLoading,
                  onAction: () => {
                    hide(false)
                  }
                } : {
                  content: 'Hide',
                  icon: HideIcon,
                  loading: hideLoading,
                  onAction: () => {
                    hide(true)
                  }
                },
                {
                  content: 'Delete',
                  icon: DeleteIcon,
                  destructive: true,
                  onAction: () => setDeleteOpen(true)
                }
              ]
            }
          ] : []}
        >
          <SearchProfile
            profileData={creatorOpen}
            onClose={() => setCreatorOpenID(null)}
          />
        </Page>
      </AppLayout>
    )
  }

  function getFormattedStatus(creator) {
    const creatorDeal = deals?.find(d => d.creatorID === creator.id && d?.status !== 'archived')
    const creatorInvite = outreachInvites?.find(i => i.creatorID === creator.id && i?.status !== 'archived')

    if (creator?.hidden) {
      return 'Hidden'
    } else if (creatorDeal?.status === 'active') {
      return 'Active'
    } else if (creatorDeal) {
      return 'Contract Created'
    } else if (creatorInvite?.status === 'replied') {
      return 'Replied'
    } else if (creatorInvite) {
      return 'Hello Sent'
    } else {
      return 'Saved'
    }
  }

  const localExtensionBannerDismissed = localStorage.getItem('extensionBannerDismissed')
  const credits = (user?.fixedCredits || 0) + (user?.credits || 0)

  const activeSub = subscriptions?.find(sub => sub.status === 'active')

  return (
    <AppLayout>
      <ManageBuckets open={manageBucketsOpen} onClose={() => setManageBucketsOpen(false)} />
      <BlockStack gap="300">
        <Banner tone={credits || someLoading ? "info" : 'critical'} >
          {
            someLoading ? <Spinner size="small" /> : (
              <BlockStack gap="100">
                {
                  credits ? (
                    <Text variant="headingMd">
                      You have {credits} Credit(s) {' '}
                    </Text>
                  ) : (
                    <Text variant="headingMd">
                      You're Out of Credits {' '}
                    </Text>
                  )
                }
                {
                  activeSub ? (
                    <Text variant="bodySm" tone="subdued">
                      You can {' '}
                      <Link url={
                        process.env.NODE_ENV === 'development'
                          ? "https://buy.stripe.com/test_bIY4hJ4hr7xhaY03ce?client_reference_id=" + auth.currentUser.uid
                          : "https://buy.stripe.com/cN2179ca9gfv6g87sw?client_reference_id=" + auth.currentUser.uid
                      }>Buy More</Link>
                      {' '} Or {' '}
                      <Link onClick={() => {
                        navigate('/settings')
                      }}>Upgrade Your Plan</Link>
                    </Text>
                  ) : (
                    <Text variant="bodySm" tone="subdued">
                      <Link onClick={() => {
                        navigate('/plan')
                      }}>Choose a Subscription</Link>
                      {' '} for More.
                    </Text>
                  )
                }
              </BlockStack>
            )
          }
        </Banner>
        {
          !user?.extensionBannerDismissed && !localExtensionBannerDismissed ? (
            <div id="ext-banner" style={{ display: extensionLoaded ? 'block' : 'none' }} >
              <Banner tone="success" icon={LogoGoogleIcon} status="info" onDismiss={() => {
                setDoc(doc(db, 'usersV2', auth?.currentUser?.uid), {
                  extensionBannerDismissed: true
                }, { merge: true })
                localStorage.setItem('extensionBannerDismissed', true)
                refetchUser()
              }}>
                <BlockStack gap="200">
                  <Text>
                    Install the PartnerUp Chrome Extension to save creators directly from Instagram, TikTok, and YouTube.
                  </Text>
                  <ButtonGroup>
                    <Button
                      target="_blank"
                      url={
                        "https://chromewebstore.google.com/detail/partnerup/ndmiddpkpghkflllbklblbgiofimjfck"
                      }>Install Extension</Button>
                  </ButtonGroup>
                </BlockStack>
              </Banner>
            </div>
          ) : null
        }
        <InlineStack align="space-between">
          <InlineStack gap="100">
            <InlineStack>
              <Icon source={PersonIcon} color="success" />
            </InlineStack>
            <Text variant="headingXl">Creators</Text>
          </InlineStack>
          <Button onClick={() => {
            exportCreators()
          }}>{
              selectedResources.length ? 'Export Selected' : 'Export All'
            }</Button>
        </InlineStack>
        <AddCreatorModal saveCreator={saveCreator} open={addCreatorOpen} onClose={() => setAddCreatorOpen(false)} />
        <InlineStack gap="300" align="space-between">
          <InlineStack gap="300" align="">
            {
              /*
                activeBucket || activeStatus ? (
                  <Button plain onClick={() => {
                    setActiveBucket(null)
                    setActiveStatus(null)
                    setSearchValue('')
                    setInitialBucket(null)
                    setInitialStatus(null)
                  }}>Clear Filters</Button>
                ) : null
                */
            }
          </InlineStack>
        </InlineStack>
        {
          /*
          <div className="container">
            <div className="arrow-steps clearfix">
              <div className="step" onClick={() => setActiveStatus('Saved')} style={activeStatus !== 'Saved' ? { backgroundColor: 'lightgrey', borderLeftColor: 'lightgrey', color: '#666' } : { backgroundColor: '#0076CB', borderLeftColor: '#0076CB' }}>
                <span>Saved</span>
                <div>
                  <Tag>{leads?.filter(lead => getFormattedStatus(lead) === 'Saved').length}</Tag>
                </div>
              </div>
              <div className="step" onClick={() => setActiveStatus('Hello Sent')} style={activeStatus !== 'Hello Sent' ? { backgroundColor: 'lightgrey', borderLeftColor: 'lightgrey', color: '#666' } : { backgroundColor: '#008FD3', borderLeftColor: '#008FD3' }}>
                <span>Hello Sent</span>
                <div>
                  <Tag>{leads?.filter(lead => getFormattedStatus(lead) === 'Hello Sent').length}</Tag>
                </div>
              </div>
              <div className="step" onClick={() => setActiveStatus('Replied')} style={activeStatus !== 'Replied' ? { backgroundColor: 'lightgrey', borderLeftColor: 'lightgrey', color: '#666' } : { backgroundColor: '#609A7E', borderLeftColor: "#609A7E" }}>
                <span>Replied</span>
                <div>
                  <Tag>{leads?.filter(lead => getFormattedStatus(lead) === 'Replied').length}</Tag>
                </div>
              </div>
              <div className="step" onClick={() => setActiveStatus('Contract Created')} style={activeStatus !== 'Contract Created' ? { backgroundColor: 'lightgrey', borderLeftColor: 'lightgrey', color: '#666' } : { backgroundColor: '#BEA42A', borderLeftColor: '#BEA42A' }}>
                <span>Created Contract</span>
                <div>
                  <Tag>{leads?.filter(lead => getFormattedStatus(lead) === 'Contract Created').length}</Tag>
                </div>
              </div>
              <div className="step" onClick={() => setActiveStatus('Active')} style={activeStatus !== 'Active' ? { backgroundColor: 'lightgrey', borderLeftColor: 'lightgrey', color: '#666' } : { backgroundColor: '#F0AB00', borderLeftColor: '#F0AB00' }}>
                <span>Active</span>
                <div>
                  <Tag>{leads?.filter(lead => getFormattedStatus(lead) === 'Active').length}</Tag>
                </div>
              </div>
            </div>
          </div>
            */
        }
        <Card padding="0">
          <IndexFilters
            sortOptions={sortOptions}
            sortSelected={sortSelected}
            queryValue={queryValue}
            queryPlaceholder="Search..."
            onQueryChange={v => setQueryValue(v)}
            onQueryClear={() => setQueryValue('')}
            onSort={setSortSelected}
            filters={[]}
            /* 
    * primaryAction={primaryAction}
            cancelAction={{
              onAction: onHandleCancel,
              disabled: false,
              loading: false,
            }}
                */
            tabs={tabs}
            selected={selected}
            onSelect={setSelected}
            canCreateNewView={false}
            // filters={filters}
            // appliedFilters={appliedFilters}
            // onClearAll={handleFiltersClearAll}
            mode={mode}
            setMode={setMode}
          />
          <IndexTable
            resourceName={{ singular: 'creator', plural: 'creators' }}
            loading={someLoading}
            selectable={true}
            emptyState={
              <EmptyState
                heading="No Creators"
                action={{ content: 'Search', onAction: () => navigate('/search') }}
              >
                <p>Change Tab, Search For or Add Creators with Extension</p>
              </EmptyState>
            }
            promotedBulkActions={[
              {
                content: 'Export Selected',
                onAction: () => {
                  exportCreators()
                },
              },
              {
                content: hideLoading ? <Spinner size="small" /> : selected > buckets?.length ? 'UnHide' : 'Hide',
                onAction: () => selected > buckets?.length ? hide(false) : hide(true),
                loading: hideLoading,
                disabled: hideLoading
              },
            ]}
            itemCount={rowMarkup?.length}
            selectedItemsCount={
              selectedResources?.length === filteredLeads?.length ? 'All' : selectedResources?.length
            }
            onSelectionChange={handleSelectionChange}
            headings={[
              { title: 'Creator' },
              { title: 'Email' },
              { title: 'Followers' },
              { title: 'Qualified' },
              { title: 'Engagement Rate' },
              { title: 'Tags' },
              { title: 'Exported' },
              { title: 'Actions' },
            ]}
          >
            {rowMarkup}
          </IndexTable>
        </Card>
      </BlockStack>
    </AppLayout>
  )
}
